import React from 'react';
import { TableRow, TableMobileRow, TableRowNoData } from './table';
import PropTypes from 'prop-types';
import Translate from '../../components/Translate';

var BonusTable = function BonusTable(_ref) {
  var data = _ref.data;
  return React.createElement(
    'div',
    null,
    React.createElement(
      'table',
      { className: 'table hidden-xs' },
      React.createElement(
        'tbody',
        null,
        React.createElement(
          'tr',
          null,
          React.createElement(
            'th',
            null,
            '#'
          ),
          React.createElement(
            'th',
            null,
            React.createElement(Translate, {
              defaultMessage: 'label.bonus_table_name',
              id: 'label.bonus_table_name'
            })
          ),
          React.createElement(
            'th',
            null,
            React.createElement(Translate, {
              defaultMessage: 'label.bonus_table_type',
              id: 'label.bonus_table_type'
            })
          ),
          React.createElement(
            'th',
            null,
            React.createElement(Translate, {
              defaultMessage: 'label.bonus_table_amount',
              id: 'label.bonus_table_amount'
            })
          ),
          React.createElement(
            'th',
            null,
            React.createElement(Translate, {
              defaultMessage: 'label.bonus_table_wagering',
              id: 'label.bonus_table_wagering'
            })
          )
        ),
        data.length > 0 && data.map(function (item) {
          return React.createElement(TableRow, { key: item.Id, data: item });
        })
      )
    ),
    React.createElement(
      'table',
      { className: 'table visible-xs' },
      React.createElement(
        'tbody',
        null,
        data.length > 0 && data.map(function (item) {
          return React.createElement(TableMobileRow, { key: item.Id, data: item });
        })
      )
    ),
    data.length === 0 && React.createElement(TableRowNoData, null)
  );
};

BonusTable.propTypes = {
  /** Collection of items */
  data: PropTypes.arrayOf(PropTypes.shape({
    /** The id/name of the bonus */
    Id: PropTypes.number,
    /** Type of currency */
    Description: PropTypes.string,
    /** Amount of bonus money */
    Amount: PropTypes.number,
    /** Type of Bonus */
    Type: PropTypes.string,
    /** Type of currency */
    Currency: PropTypes.string,
    /** Amount of required wagering remaining */
    WageringRequirmentRemaining: PropTypes.number,
    /** Amount of wagering required */
    WageringRequirment: PropTypes.number
  }))
};

export default BonusTable;